import { render, staticRenderFns } from "./AnnotationLinksPreview.vue?vue&type=template&id=3b469a79&scoped=true"
import script from "./AnnotationLinksPreview.vue?vue&type=script&lang=js"
export * from "./AnnotationLinksPreview.vue?vue&type=script&lang=js"
import style0 from "./AnnotationLinksPreview.vue?vue&type=style&index=0&id=3b469a79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b469a79",
  null
  
)

export default component.exports